import { format } from "date-fns"
import { countDisenchantedBuildings, formatDate, getLastSession } from "../../../core/utils/constants"

// Mirrors the "Account info" rows shown on Dashboard/{game}.js so the copy
// preview looks identical to what the operator already sees on the dashboard.
// Add a new game by adding one extractor here and registering it below.

const getFormattedSession = (data, attr) => {
    if (!data?.[attr]?.hasOwnProperty("_lastSessions")) {
        throw new Error("No session date")
    }
    return formatDate(getLastSession(data[attr]["_lastSessions"]))
}

const extractCM = (data) => {
    let lastSession = "N/A"
    try {
        lastSession = getFormattedSession(data, "LastSessionsState")
    } catch (e) {
        try {
            lastSession = getFormattedSession(data, "SessionsState")
        } catch (e) {
            // no session data available
        }
    }

    return [
        ["Registration Date", format(data.RegDate * 1000, "dd.MM.yyyy HH:mm:ss")],
        ["Last session", lastSession],
        ["Facebook ID", data?.["FacebookID"] ?? "N/A"],
        ["User ID", data?.["UserID"] ?? "N/A"],
        ["Global User ID", data["ServerSyncState"]?.["globalUserID"] ?? "N/A"],
        ["Username", data?.["ProfileState"]?.["_nickname"] ?? "N/A"],
        ["Next level", data?.["Match3Levels"]?.["NextLevelId"] ?? "N/A"],
        [
            "Houses disenchanted",
            Array.isArray(data?.["Buildings"]?.["States"])
                ? `${countDisenchantedBuildings(data.Buildings.States)}/53`
                : "N/A"
        ],
        ["Current version", data?.["CurrentClientVersion"] ?? "N/A"]
    ]
}

const extractDS = (data) => [
    ["User ID", data.UserID],
    ["User Seed", data.UserSeed],
    ["Timespend", data.Timespend],
    ["Timestamp", format(new Date(data.Timestamp * 1000), "dd.MM.yyyy HH:mm:ss")],
    ["SaveID", data.SaveID],
    ["InstallVersion", data.InstallVersion],
    ["Current version", data.CurrentVersion],
    ["FacebookProfile", data.Records?.FacebookProfile?.Connected?.toString()]
]

const extractTOH = (data) => [
    ["User", data?.User],
    ["ClientVer", data?.ClientVer?._major + "." + data?.ClientVer?._minor + "." + data?.ClientVer?._build],
    ["InitialClientVer", data.InitialClientVer?._major + "." + data.InitialClientVer?._minor + "." + data.InitialClientVer?._build],
    ["Reg", data.hasOwnProperty("Reg") ? format(data?.Reg * 1000, "dd.MM.yyyy HH:mm:ss") : 0],
    ["SessionTimestamp", data.hasOwnProperty("SessionTimestamp") ? format(data?.SessionTimestamp * 1000, "dd.MM.yyyy HH:mm:ss") : 0],
    ["PrevSessionTimestamp", data.hasOwnProperty("PrevSessionTimestamp") ? format(data?.PrevSessionTimestamp * 1000, "dd.MM.yyyy HH:mm:ss") : 0],
    ["SaveId", data?.SaveId]
]

const extractMC = (data) => [
    ["User ID", data.UserID],
    ["User Seed", data.UserSeed],
    ["Timespend", data.Timespend],
    ["Timestamp", format(new Date(data.Timestamp * 1000), "dd.MM.yyyy HH:mm:ss")],
    ["SaveID", data.SaveID],
    ["InstallVersion", data.InstallVersion],
    ["Current version", data.CurrentVersion],
    ["FacebookProfile", data.Records?.FacebookProfile?.Connected?.toString()]
]

export const accountInfoExtractors = {
    cm: extractCM,
    ds: extractDS,
    toh: extractTOH,
    mc: extractMC
}
